import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import { Row, Col, Form } from 'react-bootstrap'
import * as styles from './_PendingApprovalAdviserProfileContactDetailsEditor.scss'
import * as commonStyles from '../../../../../common/_common.scss'
import ContactNumberInput from '../../../../../common/forms/ContactNumberInput'
import EmailAddressInput from '../../../../../common/forms/EmailAddressInput'
import { connect } from 'react-redux'
import { modificationStates } from '../../../../../common/ReducerHelperFunctions/listDifferenceComputer'
import { bindActionCreators } from 'redux'
import {
  addNewContactNumber
  , startEditingAdviserProfileContactNumbers
  , stopEditingAdviserProfileContactNumbers
  , cancelEditingAdviserProfileContactNumbers
  , setContactNumber
  , deleteContactNumberWrapper
  , cancelDeletingContactNumber
  , setContactNumberDeleted
  , setPublicContactEmailAddress
  , startEditingPublicContactEmailAddress
  , stopEditingPublicContactEmailAddress
  , cancelEditingPublicContactEmailAddress
  , showDeleteContactNumberModal
} from './pendingApprovaladviserProfileContactDetailsEditorActions'
import PropTypes from 'prop-types';

class AdviserProfileContactDetailsEditor extends React.Component {
  static propTypes = {
    pendingApprovalProfile: PropTypes.object.isRequired,
    publishedProfile: PropTypes.object.isRequired,
    validationstate: PropTypes.object.isRequired,
    formIsValid: PropTypes.bool.isRequired,

    allContactNumberTypes: PropTypes.array.isRequired,
    editingContactNumbers: PropTypes.bool.isRequired,
    loadingContactNumbers: PropTypes.bool.isRequired,
    startEditingContactNumbers: PropTypes.func.isRequired,
    stopEditingContactNumbers: PropTypes.func.isRequired,
    canceleditingContactNumbers: PropTypes.func.isRequired,
    addNewContactNumber: PropTypes.func.isRequired,
    setContactNumber: PropTypes.func.isRequired,
    editingContactNumbersIndex: PropTypes.number,
    deleteContactNumber: PropTypes.func.isRequired,
    deleteContactNumberModal: PropTypes.bool.isRequired,
    cancelDeletingContactNumber: PropTypes.func.isRequired,
    deletingContactNumberIndex: PropTypes.number.isRequired,
    showDeleteContactNumberModal: PropTypes.func.isRequired,
    setContactNumberDeleted: PropTypes.func.isRequired,
    deletingContactNumber: PropTypes.bool.isRequired,
    contactDetailsModifications: PropTypes.object.isRequired,

    setPublicContactEmailAddress: PropTypes.func.isRequired,
    startEditingPublicContactEmailAddress: PropTypes.func.isRequired,
    stopEditingPublicContactEmailAddress: PropTypes.func.isRequired,
    cancelEditingPublicContactEmailAddress: PropTypes.func.isRequired,
    editingPublicContactEmailAddress: PropTypes.bool.isRequired,
    loadingPublicContactEmailAddress: PropTypes.bool.isRequired
  }

  componentDidMount () {
    this.setState({})
  }

  constructor (props) {
    super(props)
    this.renderEditor = this.renderEditor.bind(this)
    this.handleNewContactNumber = this.handleNewContactNumber.bind(this)
    this.handleContactNumber = this.handleContactNumber.bind(this)
    this.handlePublicContactEmailAddress = this.handlePublicContactEmailAddress.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.deletingContactNumber && this.props.deletingContactNumber) {
      this.props.setContactNumberDeleted();
    }
  }

  handleNewContactNumber (contactNumberType) {
    this.props.addNewContactNumber(contactNumberType)
  }

  handleContactNumber (validationResult, value) {
    this.props.setContactNumber(validationResult, value)
  }

  handlePublicContactEmailAddress (validationResult, value) {
    this.props.setPublicContactEmailAddress(validationResult, value)
  }

  createModificationClass (modificationState) {
    switch (modificationState) {
      case modificationStates.added:
        return commonStyles['item-added']
      case modificationStates.deleted:
        return commonStyles['item-deleted']
      case modificationStates.modified:
        return commonStyles['field-was-modified']
      default:
        return ''
    }
  }

renderEditor () {
  const contactDetails =
    this.props.pendingApprovalProfile?.contactDetails

  if (!contactDetails) {
    return null
  }

  const contactNumbers = contactDetails.contactNumbers || []

  let contactNumberType =
    this.props.allContactNumberTypes?.find(
      el => el.contactNumberType === 'Phone Number'
    )

  if (!contactNumberType && this.props.allContactNumberTypes?.length > 0) {
    contactNumberType = this.props.allContactNumberTypes[0]
  }

 

  return (
    <div>
      <form className={styles['form-bottom-margin']}>
        <h4 className={styles['title']}>Contact Details</h4>

        <Row>
          <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
            <Form.Group>
              <EmailAddressInput
                id='public-contact-email-address'
                label='Email address (for contact page)'
                value={
                  contactDetails?.publicContactEmailAddress ?? ''
                }
                validation={
                  this.props.validationstate?.publicContactEmailAddress
                }
                setEmail={this.handlePublicContactEmailAddress}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
<ContactNumberInput
  id='contactNumber'
  value={
    contactNumbers[0]?.contactNumber || ''
  }
  label='Phone Number (for contact page)'
  validation={
    this.props.validationstate?.contactNumbers || {
      isInvalid: false,
      message: null
    }
  }
  setNumber={(validationResult, value) => {
    this.handleContactNumber(validationResult, {
      contactNumber: value,
      contactNumberType: contactNumberType.contactNumberType,
      contactNumberTypeId: contactNumberType.contactNumberTypeId,
      modificationState: contactNumbers[0]?.modificationState
    })
  }}
/>
          </Col>
        </Row>
      </form>
    </div>
  )
}
  render () {
    if (this.props.editingContactNumbers || this.props.editingPublicContactEmailAddress) {
      return this.renderEditor()
    }
    return null
  }
}

const mapStateToProps = ({ adviserProfileApprovalEditorContainer }) => {
  return {
    formIsValid: adviserProfileApprovalEditorContainer.contactDetails.isInvalid.formIsValid,
    validationstate: adviserProfileApprovalEditorContainer.contactDetails.isInvalid,
    editingContactNumbers: adviserProfileApprovalEditorContainer.contactDetails.editingContactNumbers,
    loadingContactNumbers: adviserProfileApprovalEditorContainer.contactDetails.loadingContactNumbers,
    submittingContactNumbers: adviserProfileApprovalEditorContainer.contactDetails.submittingContactNumbers,
    deletingContactNumber: adviserProfileApprovalEditorContainer.contactDetails.deletingContactNumber,
    deleteContactNumberModal: adviserProfileApprovalEditorContainer.contactDetails.deleteContactNumberModal,
    deletingContactNumberIndex: adviserProfileApprovalEditorContainer.contactDetails.deletingContactNumberIndex,
    editingContactNumbersIndex: adviserProfileApprovalEditorContainer.contactDetails.editingIndex,
    allContactNumberTypes: adviserProfileApprovalEditorContainer.allContactNumberTypes,
    editingPublicContactEmailAddress: adviserProfileApprovalEditorContainer.contactDetails.editingPublicContactEmailAddress,
    loadingPublicContactEmailAddress: adviserProfileApprovalEditorContainer.contactDetails.loadingPublicContactEmailAddress,
    contactDetailsModifications: adviserProfileApprovalEditorContainer.contactDetails.contactDetailsModifications
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    startEditingContactNumbers: startEditingAdviserProfileContactNumbers,
    stopEditingContactNumbers: stopEditingAdviserProfileContactNumbers,
    setContactNumber: setContactNumber,
    addNewContactNumber: addNewContactNumber,
    canceleditingContactNumbers: cancelEditingAdviserProfileContactNumbers,
    deleteContactNumber: deleteContactNumberWrapper,
    showDeleteContactNumberModal: showDeleteContactNumberModal,
    cancelDeletingContactNumber: cancelDeletingContactNumber,
    setContactNumberDeleted: setContactNumberDeleted,

    setPublicContactEmailAddress: setPublicContactEmailAddress,
    startEditingPublicContactEmailAddress: startEditingPublicContactEmailAddress,
    stopEditingPublicContactEmailAddress: stopEditingPublicContactEmailAddress,
    cancelEditingPublicContactEmailAddress: cancelEditingPublicContactEmailAddress
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (AdviserProfileContactDetailsEditor))
